// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XTg3goWemG {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.XTg3goWemG h4 {
  line-height: 3em;
}
.XTg3goWemG .N2IrIzx2BB {
  float: left;
  width: 100%;
}
.XTg3goWemG .qPws228_ss {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.XTg3goWemG .qPws228_ss:hover {
  cursor: pointer;
}
.XTg3goWemG .qPws228_ss:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.nB0vcS43Tx .mkREVDTET6:focus {
  outline: none;
}
.nB0vcS43Tx .mkREVDTET6.ki4tqe5exu.eg_dNB0zTJ {
  background: #375A88;
}
.nB0vcS43Tx .mkREVDTET6.ki4tqe5exu.eg_dNB0zTJ span {
  color: #fff;
}
.nB0vcS43Tx .eg_dNB0zTJ {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.nB0vcS43Tx .eg_dNB0zTJ:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.nB0vcS43Tx input {
  height: 38px;
  min-width: 220px;
}
.qPws228_ss.Eo7dx_STL6 {
  background: #410102;
}
.qPws228_ss.aPgUHs_Ctj {
  background: #911318;
}
.qPws228_ss.EauQQWdAEU {
  background: #D8293B;
}
.qPws228_ss.WeH5R8nHav {
  background: #F2373C;
}
.qPws228_ss.yeL9So1zu9 {
  background: #FC4448;
}
.qPws228_ss.W4GJqOeh9o {
  background: #ED535E;
}
.qPws228_ss.YFlbHQyuLE {
  background: #E34926;
}
.qPws228_ss.JrjhcXd4LU {
  background: #FC562B;
}
.qPws228_ss.O6N4UjWfpK {
  background: #FC6722;
}
.qPws228_ss.m9NmTxsKw6 {
  background: #FD7F24;
}
.qPws228_ss.VpQqRDbe30 {
  background: #FD8D26;
}
.qPws228_ss.llNJTjoaD1 {
  background: #EC9C3E;
}
.qPws228_ss.Yj1X_KxHEN {
  background: #0e673a;
}
.qPws228_ss.R6Uzl0DqZA {
  background: #208740;
}
.qPws228_ss.aYnZ1AK2KV {
  background: #239718;
}
.qPws228_ss.kei_XyuGXI {
  background: #55A84D;
}
.qPws228_ss.eSz4NhoPUo {
  background: #4BBE5A;
}
.qPws228_ss.EPvzWegx59 {
  background: #0CCA6A;
}
.qPws228_ss.I9XVyZ4A7A {
  background: #0A3C64;
}
.qPws228_ss.o6z57pz5_L {
  background: #0d487a;
}
.qPws228_ss.CEhHrN5R5r {
  background: #10538d;
}
.qPws228_ss.IMppgQLSMj {
  background: #115A99;
}
.qPws228_ss.sYX1t54zc_ {
  background: #3387E2;
}
.qPws228_ss.JCRLxBiOsq {
  background: #1BA9CF;
}
.qPws228_ss.f5avd8iiUM {
  background: #d27c02;
}
.qPws228_ss.yJmuaqfyFh {
  background: #fb9402;
}
.qPws228_ss.QYKb1GrSgI {
  background: #FD9B30;
}
.qPws228_ss.bQ1ZTaLFrD {
  background: #FDBE2D;
}
.qPws228_ss.gHmD_XeqPZ {
  background: #FED831;
}
.qPws228_ss.sC0BbCThDj {
  background: #FFFD38;
}
.qPws228_ss.ytGFyQOfx4 {
  background: #2D215C;
}
.qPws228_ss.yC75krYMPC {
  background: #483C83;
}
.qPws228_ss.f3Dio3A2yV {
  background: #58518d;
}
.qPws228_ss.HUOy_90uTf {
  background: #7068A9;
}
.qPws228_ss.BX1TsMN8EG {
  background: #7f78b2;
}
.qPws228_ss.nQNE37HpbB {
  background: #8f88bc;
}
.qPws228_ss.IWJV1OItyu {
  background: #000;
}
.qPws228_ss.eoSxR8SANT {
  background: #282626;
}
.qPws228_ss.vOOFyuFifM {
  background: #242222;
}
.qPws228_ss.w2MtzgBo79 {
  background: #353838;
}
.qPws228_ss.Y_55wpK8Gn {
  background: #666;
}
.qPws228_ss._gAaZmSzhh {
  background: #999;
}
.isGgU4WJGN {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.isGgU4WJGN .T_ykv_NT8i {
  display: none;
}
.ymjd93vrbG {
  min-width: 1122px;
}
.JuSQ7mKLNv {
  display: flex;
  justify-content: space-between;
  padding: 0 18px;
  height: 46px;
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
}
.JuSQ7mKLNv .X20p9UcGjj {
  font-size: 12px;
  margin: 14px 0px;
}
.JuSQ7mKLNv .X20p9UcGjj .ku3SjORm54 {
  margin-left: 2px;
}
.JuSQ7mKLNv .PgfQrWFtF8 {
  min-width: 202px;
  margin: 6px 0px;
  height: 32px;
  border-radius: 30px;
  border: 1px solid #e5e5e5;
}
.JuSQ7mKLNv .PgfQrWFtF8 .heYa_75D0H {
  border: none;
}
.JuSQ7mKLNv .PgfQrWFtF8 .Sb0x28yVil {
  margin-left: 14px;
  margin-right: 12px;
}
.JuSQ7mKLNv .PgfQrWFtF8 .uHeUCyf_TL {
  padding-right: 16px;
  color: initial;
}
.y_PECNl5n3 {
  height: 536px;
}
.y_PECNl5n3 .a_5wa8aCv0 {
  display: flex;
  justify-content: space-between;
  height: 40px;
  border-radius: 3px;
  overflow: hidden;
  margin: 12px 18px 20px 18px;
}
.y_PECNl5n3 .a_5wa8aCv0 .iRFmR8XrJb {
  width: 40px;
  text-align: center;
  background-color: #ffc20e;
}
.y_PECNl5n3 .a_5wa8aCv0 .iRFmR8XrJb i {
  font-size: 14px;
  color: #F5F6FA;
  margin: 12px;
}
.y_PECNl5n3 .a_5wa8aCv0 .e1q8zeVSon {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: rgba(255, 194, 14, 0.1);
  padding: 6px 10px;
}
.y_PECNl5n3 .a_5wa8aCv0 .e1q8zeVSon .LE2vh6MuYk {
  font-size: 11px;
  line-height: 14px;
}
.y_PECNl5n3 .a_5wa8aCv0 .e1q8zeVSon .cHZc3PVuJa {
  font-weight: bold;
}
.y_PECNl5n3 .PEBhC_Gkql {
  margin: 0px 18px 12px 18px;
}
.y_PECNl5n3 .PEBhC_Gkql .uM_27PAA0u {
  width: 100%;
  text-align: center;
  height: 200px;
  padding: 40px;
}
.y_PECNl5n3 .PEBhC_Gkql .OYis394Ff1 > i {
  font-size: 60px;
}
.y_PECNl5n3 .PEBhC_Gkql .uM_27PAA0u > h3 {
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  margin-top: 8px;
}
.y_PECNl5n3 .PEBhC_Gkql .l6044Z1T5R {
  display: flex;
  flex-wrap: wrap;
}
.y_PECNl5n3 .PEBhC_Gkql .l6044Z1T5R .aZ4J5BqlyI {
  width: 23.5%;
}
.ymjd93vrbG .U_ukEd6nb7 {
  text-align: center;
  padding: 92px 372px;
}
.ymjd93vrbG .U_ukEd6nb7 .WWNz4LAq9z > i {
  font-size: 60px;
}
.ymjd93vrbG .U_ukEd6nb7 .Hm7Vc91xVI {
  margin-bottom: 8px;
  margin-top: 28px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
}
.ymjd93vrbG .U_ukEd6nb7 .NHnMwAJEDN {
  font-size: 12px;
  padding: 0 34px;
  margin-top: 0;
}
.ymjd93vrbG .U_ukEd6nb7 .OElrJpZiDy {
  margin: 0 auto;
}
.ymjd93vrbG .U_ukEd6nb7 .SkGXUr1BM5 {
  font-size: 12px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `XTg3goWemG`,
	"color-row": `N2IrIzx2BB`,
	"color-tile": `qPws228_ss`,
	"picker-component": `nB0vcS43Tx`,
	"picker-element": `mkREVDTET6`,
	"active": `ki4tqe5exu`,
	"btn": `eg_dNB0zTJ`,
	"red-1": `Eo7dx_STL6`,
	"red-2": `aPgUHs_Ctj`,
	"red-3": `EauQQWdAEU`,
	"red-4": `WeH5R8nHav`,
	"red-5": `yeL9So1zu9`,
	"red-6": `W4GJqOeh9o`,
	"orange-1": `YFlbHQyuLE`,
	"orange-2": `JrjhcXd4LU`,
	"orange-3": `O6N4UjWfpK`,
	"orange-4": `m9NmTxsKw6`,
	"orange-5": `VpQqRDbe30`,
	"orange-6": `llNJTjoaD1`,
	"green-1": `Yj1X_KxHEN`,
	"green-2": `R6Uzl0DqZA`,
	"green-3": `aYnZ1AK2KV`,
	"green-4": `kei_XyuGXI`,
	"green-5": `eSz4NhoPUo`,
	"green-6": `EPvzWegx59`,
	"blue-1": `I9XVyZ4A7A`,
	"blue-2": `o6z57pz5_L`,
	"blue-3": `CEhHrN5R5r`,
	"blue-4": `IMppgQLSMj`,
	"blue-5": `sYX1t54zc_`,
	"blue-6": `JCRLxBiOsq`,
	"yellow-1": `f5avd8iiUM`,
	"yellow-2": `yJmuaqfyFh`,
	"yellow-3": `QYKb1GrSgI`,
	"yellow-4": `bQ1ZTaLFrD`,
	"yellow-5": `gHmD_XeqPZ`,
	"yellow-6": `sC0BbCThDj`,
	"purple-1": `ytGFyQOfx4`,
	"purple-2": `yC75krYMPC`,
	"purple-3": `f3Dio3A2yV`,
	"purple-4": `HUOy_90uTf`,
	"purple-5": `BX1TsMN8EG`,
	"purple-6": `nQNE37HpbB`,
	"black-1": `IWJV1OItyu`,
	"black-2": `eoSxR8SANT`,
	"black-3": `vOOFyuFifM`,
	"black-4": `w2MtzgBo79`,
	"black-5": `Y_55wpK8Gn`,
	"black-6": `_gAaZmSzhh`,
	"picker-theme": `isGgU4WJGN`,
	"arrow-regular": `T_ykv_NT8i`,
	"existing-file": `ymjd93vrbG`,
	"existing-file__search": `JuSQ7mKLNv`,
	"search__label": `X20p9UcGjj`,
	"search__job": `ku3SjORm54`,
	"search-input__root": `PgfQrWFtF8`,
	"search-input__detail": `heYa_75D0H`,
	"search-input__icon": `Sb0x28yVil`,
	"search-input__end-icon": `uHeUCyf_TL`,
	"existing-file__assets": `y_PECNl5n3`,
	"assets__warning": `a_5wa8aCv0`,
	"assets-warning__icon": `iRFmR8XrJb`,
	"warning-label__root": `e1q8zeVSon`,
	"warning-label__text": `LE2vh6MuYk`,
	"warning-label__text--bold": `cHZc3PVuJa`,
	"assets__list": `PEBhC_Gkql`,
	"searching-asset": `uM_27PAA0u`,
	"searching-asset__icon": `OYis394Ff1`,
	"list-asset__root": `l6044Z1T5R`,
	"asset__root": `aZ4J5BqlyI`,
	"warning-file__assets": `U_ukEd6nb7`,
	"warning-assets__icon": `WWNz4LAq9z`,
	"warning-assets__title": `Hm7Vc91xVI`,
	"warning-assets__content": `NHnMwAJEDN`,
	"warning-btn": `OElrJpZiDy`,
	"warning-btn__icon": `SkGXUr1BM5`
};
export default ___CSS_LOADER_EXPORT___;
